/**************************************************
 * Nombre:       Dialogo_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete, TableRestaurantOutlined} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Reserva from "../Formularios/Formulario_Reserva";
import {useEffect, useState} from "react";
import {buscarMesasDisponiblesDiaHora} from "../../CodNegocio/Mesas/buscarMesasDisponiblesDiaHora";
import Tarjeta_Mesa_Vista_Rerserva from "../Tarjeta/Tarjeta_Mesa_Vista_Rerserva";
import {combinarFechasHora} from "../../Modulo_formularios/Funciones/combinarFechasHora";
import dayjs from "dayjs";
import {enviarNotificacionReserva} from "../../CodNegocio/Notificaciones/enviarNotificacionReserva";

const Dialogo_Reserva = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos ? datos : {numHoras: 1}})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })
    const [mesasDisponibles, setMesasDisponibles] = useState([]);
    const [escogida, setEscogida] = useState([]);


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        entidad.fechaInicio = combinarFechasHora({fecha: entidad.fechaInicio, fechaHora: entidad.horaInicio})
        entidad.fechaFin = dayjs(entidad.fechaInicio).add(entidad.numHoras).valueOf()


        if (!entidad.id){
            await enviarNotificacionReserva(entidad)
        }

        let dox = await guardarDoc('reservaciones', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

    }


    const cambia = (e) => {
        setEscogida(e)
        props.setValue('idMesa', e.id)
        props.setValue('nombreMesa', e.nombre)
    }

    const obtenerDisponibles = async () => {

        let valores = props.getValues()
        let mesas = await buscarMesasDisponiblesDiaHora({
            fecha: valores.fechaInicio,
            hora: valores.horaInicio,
            tiempo: valores.numHoras
        })

        setMesasDisponibles(mesas)

    }

    const borrar = async () => {
        await borrarDoc('reservaciones', datos.id)
        terminar({aviso: 'Reserva borrada'})
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Reserva props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Button
                    onClick={() => obtenerDisponibles()}
                    startIcon={<TableRestaurantOutlined/>}>Buscar Mesas Disponibles</Button>
            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{mt: 2}}
            >

                {mesasDisponibles.map((item, index) => (
                    <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Mesa_Vista_Rerserva item={item} escogida={escogida} cambia={cambia}/>
                    </Grid>
                ))}

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Reserva